<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Price Model Name"
                  v-model="priceModel.name"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="priceModel.description"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="priceModel.id">
                <v-text-field label="Created Date" v-model="createdDate" type="text" readonly></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="priceModel.id">
                <v-text-field
                  label="Created By"
                  v-model="priceModel.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="priceModel.id">
                <v-text-field label="Updated Date" v-model="updatedDate" type="text" readonly></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="priceModel.id">
                <v-text-field
                  label="Updated By"
                  v-model="priceModel.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="priceModel.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn color="success" @click="addPriceModelDetail()">
                    Add Price Model Detail
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex xs1>Code</v-flex>
                  <v-flex xs5>Product</v-flex>
                  <v-flex xs2>Unit</v-flex>
                  <v-flex xs1>Unit Cost</v-flex>
                  <v-flex xs1>Unit Price</v-flex>
                  <v-flex xs1>Selling Price</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(priceModelDetail, index) in priceModel.priceModelDetailList"
                  :key="index"
                >
                  <v-flex xs1>
                    <v-text-field
                      placeholder="Select code"
                      v-model="priceModelDetail.productCode"
                      @click="showProducts(), selectedIndex = index"
                      :rules="rules.codeRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                    <v-text-field
                      v-model="priceModelDetail.productName"
                      :loading="showAutocompleteLoading"
                      label="Product"
                      :readonly="true"
                      :rules="rules.nameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-autocomplete
                      v-model="priceModelDetail.factorUnitName"
                      :loading="showAutocompleteLoading"
                      :hide-no-data="true"
                      :items="priceModelDetail.productUnits"
                      color="blue-grey lighten-2"
                      item-value="factorUnitName"
                      item-text="factorUnitName"
                      menu-props="auto"
                      label="Select"
                      @change="option => initPrice(option,index)"
                      :rules="rules.unitRules"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs1>
                    <v-text-field
                      v-model="priceModelDetail.unitCost"
                      type="number"
                      min="0"
                      oninput="this.value = Math.abs(this.value)"
                      :readonly="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-text-field
                      type="number"
                      v-model="priceModelDetail.unitPrice"
                      min="0"
                      oninput="this.value = Math.abs(this.value)"
                      :readonly="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-text-field
                      v-model="priceModelDetail.sellingPrice"
                      type="number"
                      min="0"
                      oninput="this.value = Math.abs(this.value)"
                      :rules="rules.sellingPriceRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      icon
                      @click="removePriceModelDetail(index, priceModelDetail.id)"
                      :disabled="index == 0"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    type="submit"
                    :disabled="btnDisabled"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="productList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="setProduct(props.item.code, selectedIndex), showProductListDialog = !showProductListDialog"
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">{{ props.item.productGroup.name }}</td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
import { PriceModelRules } from "../../helpers/validation-rules";
import { PriceModel, PriceModelDetail } from "../../models/model";
import { productService } from "../../services/product-service";
import { priceModelService } from "../../services/price-model-service";

export default {
  name: "PriceModelDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Price Model",
        disabled: false,
        to: "price-models"
      },
      {
        text: "Price Model Detail",
        disabled: true
      }
    ],
    productList: [],
    productUnitList: [],
    priceModel: new PriceModel(),
    oldPriceModel: new PriceModel(),
    priceModelDetail: new PriceModelDetail(),
    rules: new PriceModelRules(),
    updatedDate: "",
    createdDate: "",
    unitCost: 0,
    unitPrice: 0,
    statusFlag: true,
    saveLoading: false,
    showAutocompleteLoading: false,
    btnDisabled: false,

    responseError: "",
    showProductListDialog: false,
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" }
    ],

    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0
    },
    totalRows: 0,
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: ""
    },
    search: null,
    code: "",
    showListLoading: false,
    selectedIndex: 0
  }),

  created() {
    this.addPriceModelDetail();
    this.getProductList();
    const id = this.$route.params.id;
    if (id != "new") {
      this.getPriceModelDetail(id);
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },

    goBack() {
      this.$router.push("/price-models");
    },

    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    initPrice(factorUnitName, index) {
      console.log("index" + index);
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.priceModel.priceModelDetailList[index].productUnits
      );
      console.log("unitCost" + productUnit.unitCost);
      console.log("unitPrice" + productUnit.sellingPrice);

      this.priceModelDetail.unitCost = productUnit.unitCost;
      this.priceModelDetail.unitPrice = productUnit.sellingPrice;
      
      
        this.priceModel.priceModelDetailList[index].sellingPrice =
          productUnit.sellingPrice;
          this.priceModel.priceModelDetailList[index].unitCost =
          productUnit.unitCost;
          this.priceModel.priceModelDetailList[index].unitPrice =
          productUnit.sellingPrice;
      
    },
    showProducts() {
      // Clean query params
      this.queryParams.productCode = "";
      this.queryParams.productName = "";
      this.queryParams.brandName = "";
      this.queryParams.categoryName = "";
      this.queryParams.productGroupName = "";
      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },

    setProduct(code, index) {
      let product = commonService.search("code", code, this.productList);
      this.priceModel.priceModelDetailList[index].productCode = product.code;
      this.priceModel.priceModelDetailList[index].productName = product.name;
      this.priceModel.priceModelDetailList[index].factorUnitName = "";
      this.priceModel.priceModelDetailList[index].productUnits =
        product.productUnits;
      this.priceModel.priceModelDetailList[index].sellingPrice = 0;
      this.priceModel.priceModelDetailList[index].unitCost = 0;
      this.priceModel.priceModelDetailList[index].unitPrice = 0;

    },

    addPriceModelDetail() {
      // deep copy
      this.priceModelDetail = new PriceModelDetail();
      let priceModelDetail = JSON.parse(JSON.stringify(this.priceModelDetail));
      this.priceModel.priceModelDetailList.push(priceModelDetail);
    },

    removePriceModelDetail(index, priceModelDetailId) {
      if (priceModelDetailId) {
        // add delete price Model Detail in id
        if (!this.priceModel.deletePriceModelDetailIds) {
          this.priceModel.deletePriceModelDetailIds = [];
        }
        this.priceModel.deletePriceModelDetailIds.push(priceModelDetailId);
      }
      this.$delete(this.priceModel.priceModelDetailList, index);
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.priceModel.id) {
        this.priceModel = new PriceModel();
        this.statusFlag = true;
        this.addPriceModelDetail();
      } else {
        this.priceModel.priceModelDetailList = [];
        this.priceModel.priceModelDetailList.push(
          this.priceModel.priceModelDetailList
        );
        this.priceModel = Object.assign({}, this.oldPriceModel);
        this.statusFlag = this.priceModel.status == "ACTIVE" ? true : false;
      }
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.priceModel.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        priceModelService
          .savePriceModel(this.priceModel)
          .then(res => {
            if (res) {
              this.goBack();
            }
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },

    getPriceModelDetail(id) {
      priceModelService
        .getPriceModelDetail(id)
        .then(res => {
          this.priceModel = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.priceModel.createdDateInMilliSeconds)
              .toISOString()
              .substring(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.priceModel.updatedDateInMilliSeconds)
              .toISOString()
              .substring(0, 10),
            "YYYY-MM-DD"
          );
          // deep copy
          this.oldPriceModel = JSON.parse(JSON.stringify(this.priceModel));
          this.statusFlag = this.priceModel.status == "ACTIVE" ? true : false;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>